// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg text{font-weight:700}.arc-section .status-legend{margin-top:-20px}.arc-section .arc-example{display:inline-block;margin-right:2em}.arc-section .arc-example .arc-total{font-size:36px;font-weight:700;margin-top:-112px}.arc-section .arc-example .arc-total,.arc-section .arc-example .arc-total-label{display:block;text-align:center;width:100%}", ""]);
// Exports
module.exports = exports;
